module.exports = "\n      <!-- Contenido de la ventana flotante -->\n      <div *ngIf=\"finalUrl\">\n            <iframe id=\"videoCall\" [src]=\"finalUrl\" style=\"width: 57vw; height: 60vh;\" frameborder=\"0\"  allow=\"camera; microphone; fullscreen; \" ></iframe>\n      </div>\n\n      <!-- <div id=\"videoCall\" style=\"padding-top: 0px; margin-top: 0px;height:60vh; width: 57vw\"></div> -->\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/video-call/video-call.component.html
// module id = ../../../../../src/app/admin/video-call/video-call.component.html
// module chunks = common